import React from "react";
import { QuestionType } from "../../../Utils/enum";
import { useTranslation } from "react-i18next";
import { cn, isValidQuantity, renderWithBold } from "../../../Utils/helper";

const QuestionCard = ({
  text,
  stt,
  typeQuestion,
  questReviewErrors,
  requiredOption,
  dataEditAble,
}) => {
  const { t } = useTranslation();

  const getCheckboxInstruction = () => {
    const exactQty = dataEditAble?.exactly_selection_quantity;
    if (isValidQuantity(exactQty)) {
      return t("quest.detailMultipleChoice.chooseMultipleOptionsRequired", {
        requiredOption: exactQty,
      });
    }

    if (isValidQuantity(requiredOption)) {
      return t("quest.detailMultipleChoice.chooseMinsXOptions", {
        minOption: requiredOption,
      });
    }

    const maxQty = dataEditAble?.maximum_selection_quantity;
    if (isValidQuantity(maxQty)) {
      return t("quest.detailMultipleChoice.chooseMaxXOptions", {
        maxOption: maxQty,
      });
    }

    // Default: at least 1 option
    return t("quest.detailMultipleChoice.chooseMultipleOptions", {
      minOption: 1,
    });
  };

  const questionTypeText = {
    [QuestionType.MCQ]: renderWithBold(
      t("quest.detailMultipleChoice.chooseOneOption"),
    ),
    [QuestionType.YESNO]: t("quest.detailMultipleChoice.chooseOneAnswer"),

    [QuestionType.CHECKBOX]: renderWithBold(getCheckboxInstruction()),
    [QuestionType.SHORT]: dataEditAble?.question_caption
      ? dataEditAble?.question_caption
      : t("quest.detailMultipleChoice.simpleReason"),
    [QuestionType.LONG]: dataEditAble?.question_caption
      ? dataEditAble?.question_caption
      : t("quest.detailMultipleChoice.elaboratePerson"),
    [QuestionType.SLIDER]: dataEditAble?.question_caption
      ? dataEditAble?.question_caption
      : t("quest.detailMultipleChoice.slideHandleToSelectOption"),
  };

  const hasCaption =
    dataEditAble?.question_caption &&
    (typeQuestion === QuestionType.MCQ ||
      typeQuestion === QuestionType.CHECKBOX);
  return (
    // <div className="flex-1 shrink gap-2.5 px-3 pt-3 pb-11 w-full text-base bg-yellow-50 rounded-xl border border-solid border-stone-200 min-h-[130px] text-zinc-800">
    //   {stt + 1}. {text}
    // </div>

    <div className="flex flex-col gap-[18px]">
      <h6
        className={cn(
          "text-lg font-bold max-[380px]:text-base",
          questReviewErrors?.hint ? "text-[#EF4056]" : "text-[#253FF6]",
        )}
      >
        Q{stt}
      </h6>
      <span
        className="text-xl font-medium text-[#333] max-[380px]:text-base"
        style={{ wordBreak: "keep-all" }}
      >
        {text}
      </span>
      {hasCaption && (
        <span className="text-base text-[#A0A0A0] ">
          {dataEditAble.question_caption}
        </span>
      )}
      <span className="text-base text-[#A0A0A0]">
        {questionTypeText[typeQuestion] || ""}
      </span>
    </div>
  );
};

export default QuestionCard;
